import { assertNever } from 'owa-assert';
export default function groupSubscriptions(subscriptions) {
    return subscriptions.reduce(function (agg, val) {
        var id = null;
        switch (val.type) {
            case 'Subscription':
                id = val.smtpInfo.smtpIdentifier;
                agg.subscriptions[id] = [val];
                break;
            case 'BrandSubscription':
                id = val.brand.brandId;
                if (!agg.brandSubscriptions[id]) {
                    agg.brandSubscriptions[id] = [];
                }
                agg.brandSubscriptions[id].push(val);
                break;
            default:
                return assertNever(val);
        }
        // If the ID was not in the list then add it.
        if (agg.orderedIds.indexOf(id) === -1) {
            agg.orderedIds.push(id);
        }
        return agg;
    }, {
        brandSubscriptions: {},
        subscriptions: {},
        orderedIds: [],
    });
}
//# sourceMappingURL=groupSubscriptions.js.map